export default (img, width, height) => {
	const canvas = document.createElement("canvas"),
		context = canvas.getContext("2d");
	canvas.width = width;
	canvas.height = height;

	// smoothing lives on the context, and sizing the canvas resets it, so it must be set after
	context.imageSmoothingEnabled = true;
	context.imageSmoothingQuality = "high";
	context.drawImage(img, 0, 0, img.width, img.height, 0, 0, width, height);
	return canvas;
};